import React from 'react'
import { Box } from '@chakra-ui/react'
import { Article } from '@leid/api-articles'
import { GetServerSideProps, NextPage } from 'next'

import { SEO } from 'components/helpers/SEO'
import { GoBackLink } from 'components/nav/GoBackLink'
import { ArticleContent, RelatedProjectIdeas } from 'components/partials/shared'
import articlesClient from 'helpers/clients/articlesClient'
import { Container } from 'styles/shared'
import { getIdFromPathname } from 'utils/getIdFromPathname'
import { tryParseAsNumber } from 'utils/parser'

type Props = {
  articles: Article[]
  article: Article | null
}

const ArticlePage: NextPage<Props> = ({ articles, article }) => {
  return (
    <>
      <SEO title={`Leid | ${article?.title}`} />
      <Container>
        <Box minHeight="76vh">
          <GoBackLink />
          {article && <ArticleContent article={article} />}
        </Box>
      </Container>

      {/* {article?.items && article.items.length >= 1 && (
        <>
          <Box display={{ base: 'none', lg: 'block' }}>
            <Container>
              <FeaturedBundle bundle={article.items[0]} />
            </Container>
          </Box>

          <Box display={{ lg: 'none' }}>
            <Container>
              <ProductBundleRent bundle={article.items[0]} />
            </Container>
          </Box>
        </>
      )} */}

      {articles && <RelatedProjectIdeas articles={articles} />}
    </>
  )
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  let article: Article | null = null
  let articles: Article[] = []

  const articleId = tryParseAsNumber(getIdFromPathname(context.params?.title?.toString()))
  if (articleId) {
    const articleResponse = await articlesClient.getArticle(articleId)
    if (articleResponse.success && articleResponse.data) {
      article = articleResponse.data
    }
  }

  const articlesResponse = await articlesClient.getArticles({ limit: 4 })
  if (articlesResponse.success && articlesResponse.data) {
    articles = articlesResponse.data.rows
  }

  return {
    props: {
      articles: JSON.parse(JSON.stringify(articles)),
      article: JSON.parse(JSON.stringify(article)),
    },
  }
}

export default ArticlePage
